// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Sbfnk","mini":"styles_mini__9Z480","header":"styles_header__CuwYr"};